export default [
  {
    name: "Notifications",
    path: "/notifications/list",
    component: () => import("@/modules/notifications/list/pages/Notifications"),
    meta: {
      ability: [
        {
          resource: "notifications",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Notifications detail",
    path: "/notifications/view/:id",
    component: () =>
      import("@/modules/notifications/list/pages/NotificationsDetails"),
    meta: {
      ability: [
        {
          resource: "notifications/:id",
          actions: ["read"],
        },
      ],
    },
  },
];
